export default __webpack_public_path__ + "e37b0a4720c697d2c833d32163ea3060.png";